import { Node, mergeAttributes } from '@tiptap/react';

declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    pageLink: {
      setPageLink: (attrs: { pageId: string; title: string }) => ReturnType;
    };
  }
}

export const PageLink = Node.create({
  name: 'pageLink',
  inline: true,
  group: 'inline',
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      pageId: { default: null },
      title: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'a[data-page-link]' }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const title = (node.attrs.title as string) || 'Untitled';
    const href = `/pages/${node.attrs.pageId}`;
    return [
      'a',
      mergeAttributes(HTMLAttributes, {
        'data-page-link': '',
        href,
        class: 'page-link',
      }),
      ['span', { class: 'page-link-icon', contenteditable: 'false' }, '📄'],
      ['span', { class: 'page-link-title' }, title],
    ];
  },

  addCommands() {
    return {
      setPageLink:
        (attrs) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs }),
    };
  },
});
